import React from 'react'
import { Row, Col, Typography, Statistic } from 'antd'
import { Slide, Zoom } from 'react-awesome-reveal'
import {
	CheckCircleOutlined,
	ThunderboltOutlined,
	ClockCircleOutlined
} from '@ant-design/icons'
import './OurPromise.css'
import { translate } from '../../../cls/TranslationContext'
const { Title, Paragraph } = Typography

const OurPromise = () => (
	<div className="promise-container">
		<Slide triggerOnce direction="up">
			<Title level={2} className="promise-title">
				{translate('home.promiseTitle')}
			</Title>
			<Paragraph className="promise-sub">
				{translate('home.promiseSubtitle')}
			</Paragraph>
		</Slide>

		<div className="promise-row">
			<Row gutter={[32, 32]} justify="center">
				{[
					{
						icon: <CheckCircleOutlined className="promise-icon" />,
						title: translate('home.promiseDelivered'),
						value: 150
					},
					{
						icon: <ThunderboltOutlined className="promise-icon" />,
						title: translate('_client.satisfaction'),
						value: 98,
						suffix: '%'
					},
					{
						icon: <ClockCircleOutlined className="promise-icon" />,
						title: translate('home.promiseDeliveryTime'),
						value: 5,
						suffix: translate('single.days')
					}
				].map((item, index) => (
					<Col xs={12} sm={12} md={8} key={index}>
						<Zoom triggerOnce delay={index * 100}>
							<div className="promise-feature">
								{item.icon}
								<Statistic
									title={item.title}
									value={item.value}
									suffix={item.suffix}
									className="promise-stat"
								/>
							</div>
						</Zoom>
					</Col>
				))}
			</Row>
		</div>
	</div>
)

export default OurPromise
